import { render, staticRenderFns } from "./PreviewTab.vue?vue&type=template&id=95dc061c&"
import script from "./PreviewTab.vue?vue&type=script&lang=js&"
export * from "./PreviewTab.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports